<template>
  <generic-preview :record="record" :hide-options="hideOptions" @edit="edit" @remove="remove">
    <preview-wrapper :record="record" :hide-options="hideOptions">
      <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col col-span-1">
          <span class="text-sm font-medium">Method of Delivery</span>
          <span class="text-sm">{{methodOfDelivery}}</span>
        </div>
        <div class="flex flex-col col-span-1">
          <span class="text-sm font-medium">Delivery Date</span>
          <span class="text-sm">{{deliveredAt || '-'}}</span>
        </div>
        <!-- <div class="flex flex-col col-span-full">
          <span class="text-sm font-medium">Notes</span>
          <span class="text-sm">{{notes || '-'}}</span>
        </div> -->
      </div>
    </preview-wrapper>
  </generic-preview>
</template>

<script>
import { computed } from 'vue';
import { format } from 'date-fns';
import { useBirthHistory } from './composables';
import GenericPreview from '@/components/medical-records/generic-preview.vue';
import PreviewWrapper from '@/components/medical-records/preview-wrapper.vue';

export default {
  components: {
    GenericPreview,
    PreviewWrapper,
  },
  props: {
    record: {
      type: Object,
      required: true,
      defafault: () => ({}),
    },
    hideOptions: {
      type: Boolean,
      default: false,
    },
    showRecordLabel: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const { remove: removeBirthHistory } = useBirthHistory();
    const methodOfDelivery = computed(() => props.record.methodOfDelivery);
    const deliveredAt = computed(() => {
      if (!props.record.deliveredAt) return;
      const date = new Date(props.record.deliveredAt);
      return format(date, 'yyyy');
    });
    // const notes = computed(() => props.record.notes);
    const createdAt = computed(() => format(new Date(props.record.createdAt), 'MM/dd/yyyy hh:mm a'));

    function edit () {
      emit('edit', props.record);
    }

    function remove () {
      removeBirthHistory({ id: props.record.id });
    }

    return {
      createdAt,
      methodOfDelivery,
      deliveredAt,
      // notes,
      edit,
      remove,
    };
  },
};
</script>
